import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "progress-modal-content" }

import { ProgressState } from "@medapro-types/common/components/ProgressHandling";
import { ProgressModalData } from "@medapro-types/common/components/ProgressModal";
import ProgressBar from "./ProgressBar.vue";

import { computed, ref, watch } from "vue";
import { useI18n } from "vue-i18n";

//#region General

export default /*#__PURE__*/_defineComponent({
  __name: 'ProgressModal',
  props: {
    progress: {},
    autoClose: { type: Boolean },
    minOpenTime: {},
    progressBarSize: { default: "sm" }
  },
  emits: ["cancel", "close", "update:progress:isShow"],
  setup(__props: any, { emit: emits }) {

const props = __props;

const intern_modalShow = ref<boolean>(false);


const { t: $t } = useI18n();
//#endregion

//#region Appearance
const buttonLabel = computed(() => {
  if (
    !props.progress.errorMessage &&
    (props.progress.state === ProgressState.Ongoing || props.progress.state === ProgressState.Cancelling) &&
    props.progress.isCancellable
  ) {
    return $t("cancel");
  }

  return $t("Close");
});

const showFooter = computed(() => {
  return props.progress.errorMessage || props.progress.isCancellable || !props.autoClose;
});

const buttonEnabled = computed(() => {
  if (props.progress.errorMessage) return true;
  if (props.progress.isCancellable) {
    if (props.progress.state === ProgressState.Ongoing) return true;
    if (props.progress.state === ProgressState.Cancelling) return false;
  }

  return props.progress.state === ProgressState.Finished && !props.autoClose;
});
//#endregion

//#region Events
const onClose = () => {
  if (props.progress.isCancellable && props.progress.state === ProgressState.Ongoing) {
    emits("cancel");
  } else {
    emits("close");
    props.progress.isShow = false;
  }
};
//#endregion

//#region Show Control
watch(
  () => props.progress.isShow,
  (nv) => {
    intern_modalShow.value = nv ?? false;
  }
);

watch(
  () => props.progress.state,
  (nv, ov) => {
    if (
      (ov === ProgressState.Cancelling && nv === ProgressState.Cancelled) ||
      ((nv === ProgressState.Finished || nv === ProgressState.Cancelled) && props.autoClose)
    ) {
      if (props.minOpenTime && props.progress.startedAt) {
        const passedTime = new Date().getTime() - props.progress.startedAt.getTime();
        const missingOpenTime = props.minOpenTime - passedTime;
        if (missingOpenTime > 0) {
          setTimeout(() => onClose(), missingOpenTime);
        } else {
          onClose();
        }
      } else {
        onClose();
      }
    }
  }
);

watch(intern_modalShow, (nv) => {
  emits("update:progress:isShow", nv);
});
//#endregion

return (_ctx: any,_cache: any) => {
  const _component_b_btn = _resolveComponent("b-btn")!
  const _component_b_modal = _resolveComponent("b-modal")!

  return (_openBlock(), _createBlock(_component_b_modal, {
    "header-close-content": "",
    id: props.progress.id,
    "dialog-class": "progress-modal",
    "body-class": "overflow-auto",
    title: props.progress.title,
    centered: "",
    "no-close-on-backdrop": "",
    "no-close-on-esc": "",
    "ok-only": "",
    "ok-title": buttonLabel.value,
    "hide-footer": !showFooter.value,
    modelValue: intern_modalShow.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((intern_modalShow).value = $event)),
    onOk: _withModifiers(onClose, ["prevent"]),
    onClose: _withModifiers(onClose, ["prevent"])
  }, {
    "modal-footer": _withCtx(({ ok }) => [
      _createVNode(_component_b_btn, {
        onClick: ok,
        variant: "primary",
        disabled: !buttonEnabled.value
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(buttonLabel.value), 1)
        ]),
        _: 2
      }, 1032, ["onClick", "disabled"])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(ProgressBar, {
          progress: props.progress,
          size: _ctx.progressBarSize
        }, null, 8, ["progress", "size"])
      ])
    ]),
    _: 1
  }, 8, ["id", "title", "ok-title", "hide-footer", "modelValue", "onOk", "onClose"]))
}
}

})